<div
  class="settings"
>
  <h2>User Settings</h2>

  <div
    [innerText]="user.Username"
    class="fake-select"
  ></div>

  <div class="label">
    Motion Username <i class="fa-solid fa-lock"></i>
  </div>

  <input
    (ngModelChange)="status = 'edited'"
    [(ngModel)]="user.Name"
    [disabled]="status === 'submitting' || status === 'succeeded'"
  >

  <div class="label">
    Full Name
  </div>

  <input
    (ngModelChange)="status = 'edited'"
    [(ngModel)]="user.Email"
    [disabled]="status === 'submitting' || status === 'succeeded'"
  >

  <div class="label">
    Email Address
  </div>

  <motn-save-revert-buttons
    #saveRevertButtonsComponent
    (clickedRevert$)="revert()"
    (clickedSave$)="submit()"
    (updatedStatus$)="updateStatus($event)"
    [status]="status"
  ></motn-save-revert-buttons>
</div>

<div
  class="notification-settings"
>
  <h2>Alarm Notifications</h2>

  <div class="toggles">
    <div class="toggle-box">
      <label
        class="toggle"
      >
        <input
          [(ngModel)]="pushNotifications"
          type="checkbox"
        >
        <span
          class="slider"
        ></span>
      </label>
      <div class="label">
        Push
        <motn-info-circle
          [message]="'Receive notifications pushed to your iOS, iPadOS, and Android devices for hub, device, and tile alarm events'"
        ></motn-info-circle>
      </div>
    </div>

    <div class="toggle-box">
      <label
        class="toggle"
      >
        <input
          [(ngModel)]="emailNotifications"
          type="checkbox"
        >
        <span
          class="slider"
        ></span>
      </label>
      <div class="label">
        Email
        <motn-info-circle
          [message]="'Receive an email at the email address associated with your account for hub, device, and tile alarm events'"
        ></motn-info-circle>
      </div>
    </div>
  </div>
</div>
